import { TutorialStep } from "..";

export const InspProgressSteps: TutorialStep[] = [
  {
    target: "#epoch-train-progress",
    content: `진행중인 학습 상태를 확인할 수 있습니다.\n 상세보기를 눌러 epoch별 학습 상태를 확인해보세요`,
    spotlightClicks: true,
    hideFooter: true,
    placement: "bottom",
    disableOverlayClose: true,
  },
  {
    target: "#epoch-card",
    content: `epoch 하나가 끝나면 해당 카드에서 오른쪽 마우스를 클릭해\n그 시점 모델의 스냅샷을 확인할 수 있습니다.`,
    spotlightClicks: true,
    hideFooter: false,
    placement: "bottom",
    disableOverlayClose: true,
  },
  {
    target: "#epoch-card",
    content: `특정 epoch의 학습/검증 진행도를 확인할 수 있고, \n 완료시에는 결과와 모델 결과 여부를 확인할 수 있습니다.`,
    spotlightClicks: false,
    hideFooter: true,
    placement: "bottom",
    nextTrigger: "#insp-result-list",
    disableOverlayClose: true,
  },
  {
    target: "#insp-result-list",
    content: `검증이 완료되면 특정 모델이 검사한 결과를 확인할 수 있습니다.`,
    spotlightClicks: true,
    hideFooter: false,
    placement: "bottom",
    disableOverlayClose: true,
  },
];
